export const IMGTYPES = {
    reference : {
        width : 1000,
        height : 600,
        fit : "contain",
    },

    jobAdImage : {
        width: 1920,
        height: 1080,
        fit: "cover",
    }
}

